import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'

// Router parses numeric-looking search values (?search=273) into numbers, so
// coerce back to string instead of failing validation.
const searchString = z.coerce.string().optional()

const testsSearchSchema = z.object({
  controlRef: searchString,
  intent: z.enum(['prepare', 'generate']).optional(),
  // Filter state, owned by ControlsTestsPage and written to the URL by nuqs so
  // a filtered list is bookmarkable. Declared here (as the raw string nuqs
  // serializes) so type-safe links can restore them — the "Tests" breadcrumb on
  // the test detail page replays them from its `listFilters` param.
  framework: searchString,
  search: searchString,
  status: searchString,
  assignee: searchString,
  labels: searchString,
  // RFC-234 inclusion (all | core | scope | extended).
  inclusion: searchString,
  // #1705 test kind (all | policy | requirement | automated | manual).
  kind: searchString,
  // RFC-226 provenance. TanStack Router JSON-parses `?auditorRequested=true`
  // before search validation, so it arrives as a boolean.
  auditorRequested: z.boolean().optional(),
  // Hide N/A checkbox. Hidden by default, so only `?hideNa=false` appears
  // (JSON-parsed to a boolean like the flag above).
  hideNa: z.boolean().optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tests'
)({
  validateSearch: testsSearchSchema,
  staticData: { pageHeader: { title: 'Tests', pad: false } },
})
